import React, { Component } from 'react';
import FormCreate from './FormCreate'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";

class Index extends Component {
    constructor(props){
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            modal: false,
            modeEdit: false,
            showTable: false,
            ErrorValues: true,
            format_association_id: "",

            form: {
                format_id: this.props.format.id,
                format_select_id: "",
                question_asociation_id: "",
                description: "",
            },

            selectedOption: {
                label: "Selecione un formato",
                format_select_id: ""
            },

            selectedOptionQuestion: {
                label: "Selecione una pregunta",
                question_asociation_id: "",
            },

            questions: [],
        }
    }

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            }
        });
    }

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false })
        }
    }

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
                if (format.id === item.id) {
                    return {
                        ...item,
                        description: format.description,
                        format_select: format.format_select
                    }
                }
                return item;
            })
        });
    }

    clearValues = () => {
        this.setState({
            modeEdit: false,
            ErrorValues: true,

            form: {
                ...this.state.form,
                description: "",
                format_select_id: "",
            },

            selectedOption: {
                label: "Selecione un formato",
                format_select_id: ""
            }
        })
    }

    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si"
        }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_associations/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                .then(response => response.json())
                .then(response => {
                    this.loadData()
                    this.messageSuccess(response)
                });
            }
        });
    };

    componentDidMount = () => {
        this.loadData();
        //this.selectConfiguration();
    }

    selectConfiguration = () => {
        let array = []

        this.props.steps_questions.map((item) => (
            array.push({ label: item.question, value: item.id })
        ))

        this.setState({
            questions: array,
        })
    }

    loadData = () => {
        fetch(`/formatos/get_format_associations/${this.props.format.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }

    loadDataSelects = () => {
        fetch(`/formatos/data_questions/${this.props.format.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            let array = []

            data.steps_questions.map((item) => (
                array.push({ label: item.question, value: item.id })
            ))

            this.setState({
                questions: array,
                modal: true
            });
        });
    }

    validationForm = () => {
        if (this.state.form.format_select_id != "" && 
            this.state.form.question_asociation_id != ""
        ) {
            this.setState({ ErrorValues: true })
            return true
        }else{
            this.setState({ ErrorValues: false })
            return false
        }
    }

    HandleClick = () => {
        if(this.validationForm()){
            if (this.state.modeEdit) {
                fetch(`/formatos/format_associations/${this.state.format_association_id}`, {
                    method: 'PATCH', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })

                    .then(res => res.json())
                    .catch(error => console.error("Error:", error))
                    .then(data => {
                        this.updateItem(data.register)
                        this.clearValues();
                        this.setState({ modal: false })
                    });
            } else {
                fetch(`/formatos/format_associations`, {
                    method: 'POST', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => res.json())
                    .catch(error => console.error("Error:", error))
                    .then(data => {
                        this.updateData(data.register)
                        this.clearValues();
                        this.setState({ modal: false, showTable: true })
                    });
            }
        }
    }


    edit = (format_association) => {
        this.setState({
            modal: true,
            modeEdit: true,
            format_association_id: format_association.id,

            form: {
                format_select_id: format_association.format_select.id,
                description: format_association.description,
                question_asociation_id: format_association.question_asociation != null ? format_association.question_asociation.id : "",
            },

            selectedOption: {
                label: `${format_association.format_select.name}`,
                format_select_id: format_association.format_select.id,
            },

            selectedOptionQuestion: {
                label: `${format_association.question_asociation != null ? format_association.question_asociation.question : "Selecione una pregunta"}`,
                question_asociation_id: format_association.question_asociation != null ? format_association.question_asociation.id : "",
            },
        })
    }

    handleChangeAutocomplete = selectedOption => {
        this.setState({
            selectedOption,
                form: {
                    ...this.state.form,
                    format_select_id: selectedOption.value
                }
        });
    };

    handleChangeAutocompleteQuestions = selectedOptionQuestion => {
        this.setState({
            selectedOptionQuestion,
                form: {
                    ...this.state.form,
                    question_asociation_id: selectedOptionQuestion.value
                }
        });
    };


    render() {
        return (
            <React.Fragment>
                {this.state.modal && (
                    <FormCreate
                        backdrop={"static"}
                        modal={this.state.modal}
                        toggle={this.toogle}
                        title={this.state.modeEdit ? "Actualizar asociacion" : "Crear asociacion"}
                        nameBnt={this.state.modeEdit ? "Actualizar" : "Crear"}

                        //form props
                        formValues={this.state.form}
                        onChangeForm={this.HandleChange}
                        submitForm={this.HandleClick}
                        errorValues={this.state.ErrorValues}

                        //select values
                        handleChangeAutocomplete={this.handleChangeAutocomplete}
                        selectedOption={this.state.selectedOption}
                        formatos={this.props.formatos}

                        //select questions 
                        handleChangeAutocompleteQuestions={this.handleChangeAutocompleteQuestions}
                        selectedOptionQuestion={this.state.selectedOptionQuestion}
                        questions={this.state.questions}

                    />
                )}

                <div className="card mb-3">
                    <div className="card-header" style={{ display: "flow-root", paddingTop: 12 }}>
                        Asociacion de formatos

                        <button
                            className="btn-shadow btn btn-info float-right"
                            onClick={() => this.loadDataSelects()}
                        >
                            Crear
                        </button>

                        <a className="float-right mr-3" data-toggle="collapse" href="#collapseExampleAssociatios" role="button" aria-expanded="false" aria-controls="collapseExampleResponsabilidades">
                            <i className="fas fa-angle-down"></i>
                        </a>
                    </div>

                    <div className="card-body p-3">
                        <div className="row">

                            <div className={`collapse ${this.state.showTable ? "show" : ""} w-100`} id="collapseExampleAssociatios">
                                <div className="col-md-12">
                                    <table className="table table-hover table-striped table-bordered" id="sampleTable">
                                        <thead>
                                            <tr>
                                                <th>Formato</th>
                                                {/*<th>Descripcion</th>*/}
                                                <th></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.data.length >= 1 ? (
                                                this.state.data.map(format_association => (
                                                    <tr key={format_association.id}>
                                                        <td>{format_association.format_select ? format_association.format_select.name : "" }</td>
                                                        {/*<td>{format_association.description}</td>*/}
                                                        {true && (
                                                            <td className="text-right" style={{ width: "10px" }}>
                                                                    <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                                        <div className="btn-group" role="group">
                                                                            <button
                                                                                className="btn-shadow btn btn-info"
                                                                                id="btnGroupDrop1"
                                                                                type="button"
                                                                                data-toggle="dropdown"
                                                                                aria-haspopup="true"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <i className="fas fa-bars"></i>
                                                                            </button>
                                            
                                                                            <div className="dropdown-menu dropdown-menu-right">

                                                                                {true && (
                                                                                    <a
                                                                                        className="dropdown-item"
                                                                                        onClick={() => this.edit(format_association)}
                                                                                        
                                                                                    >
                                                                                        Editar
                                                                                    </a>
                                                                                )}

                                                                                {true && (  
                                                                                    <button
                                                                                        onClick={() => this.delete(format_association.id)}
                                                                                        className="dropdown-item"
                                                                                    >
                                                                                        Eliminar
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))
                                            ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            <div className="text-center mt-4 mb-4">
                                                                <h4>No hay registros</h4>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Index;
